<div class="page-izi" :class="bindingClass">
  <div class="header-pages"></div>
  <div class="content-pages">
    <slot />
  </div>
</div>
<IziDialog />